import { GetStaticProps } from "next/types"
import { SSRConfig } from "next-i18next"
import { Page } from "types/page"
import { ParsedUrlQuery } from "querystring"
import nextI18nextConfig from "next-i18next.config"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import markdownToHtml from "@cs/lib/markdown/markdownToHtml"
import { getMDPageByName } from "@cs/lib/markdown/getMDPageByName"
import { NextSeo } from "next-seo"
import { RejectCookiesButton } from "@cs/components/reject-cookies"

interface TermsOfUsePageProps extends SSRConfig {
  title: string
  content: string
}

const PrivacyPage: Page<TermsOfUsePageProps> = ({ title, content }) => (
  <main>
    <NextSeo title={title} />
    <article dangerouslySetInnerHTML={{ __html: content }} className="md_page" />
    <RejectCookiesButton />
  </main>
)

export default PrivacyPage

export const getStaticProps: GetStaticProps<TermsOfUsePageProps, ParsedUrlQuery> = async ({
  locale,
}) => {
  const { title, content } = getMDPageByName("privacy")
  const parsedPrivacyContent = await markdownToHtml(content)

  return {
    props: {
      content: parsedPrivacyContent,
      title: title,
      ...(await serverSideTranslations(
        locale ?? "en",
        ["common", "footer", "nav", "olympiad", "landing-page"],
        nextI18nextConfig,
      )),
    },
  }
}
